export default __webpack_public_path__ + "static/Shepherd-Pie-COOKED-3-555865d3c09f18f4a926e87366b91053.png";